import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const StyledTree = /*#__PURE__*/styled('ul').withConfig({
  componentId: "sc-storm-ui-30065889__sc-128h40x-0"
})(["list-style:none;display:flex;flex-direction:column;justify-content:space-evenly;padding:0;margin:0;&&[role=\"tree\"] > [role=\"treeitem\"]:first-of-type > div:first-of-type{border-top-left-radius:", ";border-top-right-radius:", ";}"], ({
  theme
}) => theme.card.radius, ({
  theme
}) => theme.card.radius);
function getBottomBorder(root, displayed) {
  if (displayed) return 'none';
  return root ? '1px solid #e7e7e7' : 'none';
}
const StyledTreeList = /*#__PURE__*/styled('li').withConfig({
  componentId: "sc-storm-ui-30065889__sc-128h40x-1"
})([":not(:last-child){border-bottom:", "}"], ({
  $root,
  $displayed
}) => getBottomBorder($root, $displayed));
const NodeWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30065889__sc-128h40x-2"
})(["display:flex;align-items:stretch;", " :hover{background:", ";", "}"], isMobile(css(["margin:0;"])), ({
  theme
}) => theme.palette.gray[50], ({
  $lastNode
}) => $lastNode && css(["border-bottom-left-radius:", ";border-bottom-right-radius:", ";"], ({
  theme
}) => theme.card.radius, ({
  theme
}) => theme.card.radius));
const RenderNodeWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30065889__sc-128h40x-3"
})(["flex-grow:1;padding:4px 0;", ""], isMobile(css(["padding:3px 0;"])));

export { NodeWrapper as N, RenderNodeWrapper as R, StyledTree as S, StyledTreeList as a };
//# sourceMappingURL=Tree.styles-BV1QedeT.js.map
